import authAxios from '@/auth/auth-axios';
import jsyaml from 'js-yaml';

export default class ScaffoldService {
  static async find(id) {
    const axios = await authAxios();
    const response = await axios.get(`/scaffold/${id}`);
    const scaffold = this.formatConfigAndSample(
      response.data,
    );
    return scaffold;
  }

  static async findAtVersion(id, version) {
    const axios = await authAxios();
    const response = await axios.get(
      `/scaffold/${id}/version/${version}`,
    );
    const scaffold = this.formatConfigAndSample(
      response.data,
    );
    return scaffold;
  }

  static formatConfigAndSample(scaffold) {
    if (!scaffold) {
      return scaffold;
    }

    scaffold.config =
      scaffold.config && jsyaml.safeLoad(scaffold.config);
    scaffold.sample =
      scaffold.sample && JSON.parse(scaffold.sample);

    return scaffold;
  }

  static async validateForCreate(id, version) {
    const axios = await authAxios();

    const response = await axios.get(`/scaffold/validate`, {
      params: {
        id,
        version,
        operation: 'create',
      },
    });

    return response.data;
  }

  static async validateForUpdate(id, version) {
    const axios = await authAxios();

    const response = await axios.get(`/scaffold/validate`, {
      params: {
        id,
        version,
        operation: 'update',
      },
    });

    return response.data;
  }

  static async create(scaffold, files) {
    const body = {
      scaffold,
      files,
    };

    const axios = await authAxios();
    return axios.post(`/scaffold`, body);
  }

  static async delete(scaffold) {
    const axios = await authAxios();
    return axios.delete(`/scaffold/${scaffold.id}`);
  }

  static async update(scaffold, files) {
    const body = {
      scaffold,
      files,
    };

    const axios = await authAxios();
    return axios.put(`/scaffold/${scaffold.id}`, body);
  }
}
